<template>
  <div class="pdf-container"></div>
</template>

<script>
import PSPDFKit from 'pspdfkit';

/**
 * PSPDFKit for Web example component.
 */
export default {
  name: 'PSPDFKit',
  /**
   * The component receives `pdfFile` as a prop, which is type of `String` and is required.
   */
  props: {
    pdfFile: { type: String, required: true },
  },
  /**
   * We wait until the template has been rendered to load the document into the library.
   */
  mounted() {
    this.loadPSPDFKit().then((instance) => {
      this.$emit('loaded', instance);
    });
  },
  /**
   * We watch for `pdfFile` prop changes and trigger unloading and loading when there's a new document to load.
   */
  watch: {
    pdfFile(val) {
      if (val) {
        this.loadPSPDFKit();
      }
    },
  },
  /**
   * Our component has the `loadPSPDFKit` method. This unloads and cleans up the component and triggers document loading.
   */
  methods: {
    async loadPSPDFKit() {
      PSPDFKit.unload('.pdf-container');
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      // Keep track of the current instance
      // so that we can use it inside of a toolbar item onPress callback.
      let instance = null;

      // PSPDFKit exposes the default list of items as PSPDFKit.defaultToolbarItems
      // This is an Array that can be filtered or customized as you please.
      const toolbarItems = PSPDFKit.defaultToolbarItems.filter((item) => /\b(sidebar-thumbnails|pager|search)\b/.test(item.type));

      toolbarItems.push({
        type: 'spacer',
      });

      // A custom item. Inside the onPress callback we can call into PSPDFKit APIs.
      toolbarItems.push({
        type: 'custom',
        id: 'my-custom-button',
        title: 'Exit',
        onPress() {
          that.$emit('on-close');
        },
      });

      return PSPDFKit.load({
        // access the pdfFile from props
        // licenseKey: process.env.VUE_APP_PSPDFKIT_LICENSE,
        toolbarItems,
        document: this.pdfFile,
        container: '.pdf-container',
      }).then((newInstance) => {
        instance = newInstance;
        return instance;
      });
    },
  },

  /**
   * Clean up when the component is unmounted so it's ready to load another document (not needed in this example).
   */
  beforeUnmount() {
    PSPDFKit.unload('.pdf-container');
  },
};
</script>

<style lang="sass" scoped>
.pdf-container
  background-color: #ffffff
  padding-top: 50px
  height: 100vh
  width: 100vw
  position: fixed
  top: 0
  left: 0
  z-index: 99999
</style>
